import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[var(--bg-secondary)]">
      <div className="bg-white rounded-2xl border border-[var(--border-subtle)] p-10 max-w-md w-full text-center" data-testid="payment-cancel-card">
        <XCircle className="w-14 h-14 text-[var(--text-muted)] mx-auto" />
        <h1 className="font-serif text-3xl mt-5">Checkout cancelled</h1>
        <p className="text-[var(--text-secondary)] mt-3">No payment was taken. The artwork is still available if you'd like to try again.</p>
        <Link to="/gallery" className="btn-gold inline-block mt-6 px-7 py-3 rounded-full text-sm font-semibold">Back to gallery</Link>
      </div>
    </div>
  );
}
